import clsx from "clsx";
import { t, TranslationKeys } from "../i18n";

import "./ContextMenuShhhhhhhhhhiiiiiiii.scss";
import "./ContextMenuNew.css"
import {
  getShortcutFromShortcutName,
  ShortcutName,
} from "../actions/shortcuts";
import { Action } from "../actions/types";
import { ActionManager } from "../actions/manager";
import { useExcalidrawAppState, useExcalidrawElements } from "./App";
import React from "react";
import {getImagePathWithTheme} from "../../../../src/utils";
import i18next from "i18next";
import {actionMindmapCopyToClipboardAsMarkdown, actionMindmapExportAsMarkdown} from "../actions/actionClipboard";
import {Popover} from "./Popover";
import { Popover as AntdPopover } from 'antd';// 👈 重命名为 AntdPopover

export type ContextMenuItem = typeof CONTEXT_MENU_SEPARATOR | Action;

export type ContextMenuItems = (ContextMenuItem | false | null | undefined)[];

type ContextMenuProps = {
  actionManager: ActionManager;
  items: ContextMenuItems;
  top: number;
  left: number;
  onClose: (callback?: () => void) => void;
};

export const CONTEXT_MENU_SEPARATOR = "separator";
export const getArrayExportMarkdown = ()=>{
    const arrayExportMarkdown = [
        actionMindmapExportAsMarkdown,
        actionMindmapCopyToClipboardAsMarkdown
    ]
    return arrayExportMarkdown;
}

export const ContextMenu = React.memo(
  ({ actionManager, items, top, left, onClose }: ContextMenuProps) => {
    const appState = useExcalidrawAppState();
    const elements = useExcalidrawElements();


    const filteredItems = items.reduce((acc: ContextMenuItem[], item) => {
      if (
        item &&
        (item === CONTEXT_MENU_SEPARATOR ||
          !item.predicate ||
          item.predicate(
            elements,
            appState,
            actionManager.app.props,
            actionManager.app,
          ))
      ) {
        acc.push(item);
      }
      return acc;
    }, []);

    return (
      <Popover
        onCloseRequest={() => {
            setTimeout(()=>{
                onClose();//不要关闭这么早，二级弹出菜单需要时间.
            },200)

        }}
        top={top}
        left={left}
        fitInViewport={true}
        offsetLeft={appState.offsetLeft}
        offsetTop={appState.offsetTop}
        viewportWidth={appState.width}
        viewportHeight={appState.height}
      >
        <ul
          className="context-menu-0"//contextmenu.scss 我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了。改不无效
          style={{background:'var(--background-color-white)',border:'none',borderRadius:'8px',minWidth:'310px'}}
          onContextMenu={(event) => event.preventDefault()}
          onMouseDown={(event) => event.stopPropagation()}
          onMouseUp={(event) => event.stopPropagation()}
            // Important: our canvas uses pointer events. If we don't stop
            // pointerdown, clicking a context-menu item may bubble into the canvas
            // and clear selection immediately after executing the action.
          onPointerDown={(event) => event.stopPropagation()}
          onPointerUp={(event) => event.stopPropagation()}
          onClick={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
          onTouchEnd={(event) => event.stopPropagation()}
        >
          {filteredItems.map((item, idx) => {
            if (item === CONTEXT_MENU_SEPARATOR) {
              if (
                !filteredItems[idx - 1] ||
                filteredItems[idx - 1] === CONTEXT_MENU_SEPARATOR
              ) {
                return null;
              }
              return <hr key={idx} className="context-menu-item-separator-0" style={{margin:'4px 0'}}/>;
            }

              const actionName = item.name;
              let label = "";
              if (item.contextItemLabel) {
                  if (typeof item.contextItemLabel === "function") {
                      label = t(
                          item.contextItemLabel(
                              elements,
                              appState,
                              actionManager.app,
                          ) as unknown as TranslationKeys,
                      );
                  } else {
                      // try {
                      //     const i18nLabel = t(
                      //         item.contextItemLabel as unknown as TranslationKeys,
                      //     );
                      //     label = i18nLabel ? i18nLabel : item.contextItemLabel;
                      // } catch (error) {
                      //     label = (item.contextItemLabel);
                      // }
                      label = i18next.t(item.contextItemLabel);
                  }
              }


            if (item.name == 'mindmapExportToMarkdown'){
                return <AntdPopover arrow={false} placement={'right'} overlayInnerStyle={{margin:'0',padding:'0'}} content={<ul
                    className="context-menu-0"//contextmenu.scss 我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了，我改不了。改不无效
                    style={{
                        background: 'var(--background-color-white)',
                        border: 'none',
                        borderRadius: '8px',
                        minWidth: '310px'
                    }}
                    onContextMenu={(event) => event.preventDefault()}>
                    {
                        getArrayExportMarkdown().map(pppp => {
                            const actionName = pppp.name;
                            let label = "";
                            if (pppp.contextItemLabel) {
                                if (typeof pppp.contextItemLabel === "function") {
                                    label = t(
                                        pppp.contextItemLabel(
                                            elements,
                                            appState,
                                            actionManager.app,
                                        ) as unknown as TranslationKeys,
                                    );
                                } else {
                                    label = i18next.t(pppp.contextItemLabel);
                                }
                            }

                            return <li
                                key={actionName}
                                data-testid={actionName}
                                onMouseDown={() => {
                                    // we need update state before executing the action in case
                                    // the action uses the appState it's being passed (that still
                                    // contains a defined contextMenu) to return the next state.
                                    onClose(() => {
                                        actionManager.executeAction(pppp, "contextMenu");
                                    });
                                }}
                            >
                                <button
                                    style={{
                                        color: actionName == 'mindmapRemoveLink' ? 'var(--color-remove)' : 'var(--text-color)',
                                        height: '34px',
                                        cursor:'pointer'
                                    }}
                                    className={clsx("contextmenu-contextmenu-hover context-menu-item-0 ", {
                                        // dangerous: (actionName === "deleteSelectedElements" || actionName == "deleteNode"),
                                        checkmark: pppp.checked?.(appState),
                                    })}
                                ><img className={'img-16'}
                                      style={{opacity: pppp.icon ? '1' : '0', marginLeft: '-4px'}}
                                      src={getImagePathWithTheme(pppp.icon)}/>
                                    <div className="context-menu-item__label"
                                         style={{fontSize: '12px'}}>{label}</div>
                                    <kbd className="context-menu-item__shortcut">
                                        {actionName
                                            ? getShortcutFromShortcutName(actionName as ShortcutName)
                                            : ""}
                                    </kbd>
                                </button>
                            </li>
                        })
                    }
                </ul>}>
                    <li
                        key={idx}
                        data-testid={actionName}>
                        <button
                            style={{
                                color: actionName == 'mindmapRemoveLink' ? 'var(--color-remove)' : 'var(--text-color)',
                                height: '34px',
                                position:'relative'
                            }}
                            className={clsx("contextmenu-contextmenu-hover context-menu-item-0 flex-row-vertical-center", {
                                // dangerous: (actionName === "deleteSelectedElements" || actionName == "deleteNode"),
                                checkmark: item.checked?.(appState),
                            })}
                        ><img className={'img-16'} style={{opacity: item.icon ? '1' : '0', marginLeft: '-4px'}}
                              src={getImagePathWithTheme(item.icon)}/>
                            <div className="context-menu-item__label" style={{fontSize: '12px'}}>{label}</div>
                            <kbd className="context-menu-item__shortcut">
                                {actionName
                                    ? getShortcutFromShortcutName(actionName as ShortcutName)
                                    : ""}
                            </kbd>

                            <img className={'img-10 margin-left-auto'} style={{position:'absolute',right:'10px'}} src={getImagePathWithTheme('right_arrow')}/>
                        </button>

                    </li>
                </AntdPopover>
            }


              return (
                  <li
                      key={idx}
                      data-testid={actionName}
                      onClick={() => {
                          // we need update state before executing the action in case
                          // the action uses the appState it's being passed (that still
                          // contains a defined contextMenu) to return the next state.
                          onClose(() => {
                              actionManager.executeAction(item, "contextMenu");
                          });
                      }}
                  >
                      <button
                          style={{
                              color: actionName == 'mindmapRemoveLink' ? 'var(--color-remove)' : 'var(--text-color)',
                              height: '34px'
                          }}
                          className={clsx("contextmenu-contextmenu-hover context-menu-item-0 ", {
                              // dangerous: (actionName === "deleteSelectedElements" || actionName == "deleteNode"),
                              checkmark: item.checked?.(appState),
                          })}
                      ><img className={'img-16'} style={{opacity: item.icon ? '1' : '0', marginLeft: '-4px'}}
                            src={getImagePathWithTheme(item.icon)}/>
                          <div className="context-menu-item__label" style={{fontSize: '12px'}}>{label}</div>
                          <kbd className="context-menu-item__shortcut">
                              {actionName
                                  ? getShortcutFromShortcutName(actionName as ShortcutName)
                                  : ""}
                          </kbd>
                      </button>
                  </li>
              );
          })}
        </ul>
      </Popover>
    );
  },
);
